import { useDelete, useList, useNavigation } from "@refinedev/core";
import {
  Button,
  Popconfirm,
  Space,
  Table,
  Tag,
  Typography,
  message,
} from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { MedicineAnnouncement } from "./types";

export const MedicineAnnouncementsTable = () => {
  const { push } = useNavigation();
  const { data, isLoading, refetch } = useList<MedicineAnnouncement>({
    resource: "medicine-announcements",
    dataProviderName: "medicineAnnouncementsDataProvider",
  });
  const { mutate: deleteAnnouncement, isLoading: deletingAnnouncement } =
    useDelete();

  const announcements = data?.data || [];

  const handleDelete = (announcement: MedicineAnnouncement) => {
    deleteAnnouncement(
      {
        dataProviderName: "medicineAnnouncementsDataProvider",
        resource: "medicine-announcements",
        id: announcement.id,
      },
      {
        onSuccess: () => {
          message.success("Анонс удален");
          refetch();
        },
        onError: (error: any) => {
          message.error(error?.message || "Не удалось удалить анонс");
        },
      }
    );
  };

  return (
    <Table<MedicineAnnouncement>
      title={() => (
        <Space>
          <strong>Анонсы</strong>
          <Button
            size="small"
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => push("/medicine/materials/announcements/create")}
          >
            Добавить анонс
          </Button>
        </Space>
      )}
      dataSource={announcements}
      loading={isLoading}
      rowKey="id"
      pagination={false}
      locale={{
        emptyText: <div style={{ margin: 56 }}>Анонсы отсутствуют</div>,
      }}
    >
      <Table.Column<MedicineAnnouncement>
        dataIndex="name"
        key="name"
        title="Название"
        render={(value, record) =>
          record.linkUrl ? (
            <Typography.Link
              href={record.linkUrl}
              target="_blank"
              rel="noreferrer"
            >
              {value}
            </Typography.Link>
          ) : (
            <Typography.Text>{value}</Typography.Text>
          )
        }
      />
      <Table.Column<MedicineAnnouncement>
        width={190}
        dataIndex="publishedAt"
        key="publishedAt"
        title="Дата публикации"
      />
      <Table.Column<MedicineAnnouncement>
        width={150}
        dataIndex="eventDateFrom"
        key="eventDateFrom"
        title="Дата начала"
      />
      <Table.Column<MedicineAnnouncement>
        width={150}
        dataIndex="eventDateTo"
        key="eventDateTo"
        title="Дата окончания"
        render={(value) => value || "-"}
      />
      <Table.Column<MedicineAnnouncement>
        dataIndex="place"
        key="place"
        title="Место"
        render={(value) => value || "-"}
      />
      <Table.Column<MedicineAnnouncement>
        width={120}
        dataIndex="isActive"
        key="isActive"
        title="Активен"
        render={(value) => (
          <Tag color={value ? "green" : "default"}>{value ? "Да" : "Нет"}</Tag>
        )}
      />
      <Table.Column<MedicineAnnouncement>
        width={220}
        fixed="right"
        key="actions"
        title="Действия"
        render={(_, record) => (
          <Space size={8} direction="vertical" style={{ width: "100%" }}>
            <Button
              size="small"
              icon={<EditOutlined />}
              onClick={() =>
                push(`/medicine/materials/announcements/edit/${record.id}`)
              }
              block
            >
              Редактировать
            </Button>
            <Popconfirm
              title="Удалить анонс?"
              okText="Удалить"
              cancelText="Отмена"
              onConfirm={() => handleDelete(record)}
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
                loading={deletingAnnouncement}
                block
              >
                Удалить
              </Button>
            </Popconfirm>
          </Space>
        )}
      />
    </Table>
  );
};
